module.exports = __webpack_public_path__ + "static/media/62.b054b7a1.png";